<template>
  <MCVExternalDataSetList />
</template>

<script>
import MCVExternalDataSetList from '@/modules/mcvExternalDataSet/components/list.vue';

export default {
  name: 'ExternalDataSets',
  components: {
    MCVExternalDataSetList,
  },
};
</script>
